import { Button, Input } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { notify } from "@/ui/chakra/notify";
import { z } from "zod";
import { useUpdateActivityLabel } from "../useCases/useUpdateActivityLabel";
import { activityLabelSchema } from "../schemas/activityLabelSchema";
import { ZoneActivityLabel, ActivityLabelType } from "../types/ActivityLabel";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";
import { Field } from "@/ui/chakra/field";

export type ActivityLabelFormInput = z.infer<typeof activityLabelSchema>;

export interface UpdateActivityLabelModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedActivityLabel: ZoneActivityLabel;
  activityLabelTypes?: ActivityLabelType[];
}

export const UpdateActivityLabelModal = ({
  isOpen,
  onClose,
  selectedActivityLabel,
}: UpdateActivityLabelModalProps) => {
  const { isPending, mutate: updateActivityLabel } = useUpdateActivityLabel();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ActivityLabelFormInput>({
    resolver: zodResolver(activityLabelSchema),
    defaultValues: {
      label: selectedActivityLabel.label,
      enabled: selectedActivityLabel.enabled,
    },
  });

  const onFormSubmit = (data: ActivityLabelFormInput) => {
    updateActivityLabel(
      { id: selectedActivityLabel.id, updatedActivityLabel: data },
      {
        onSuccess: () => {
          notify.success("Etiqueta actualizada");
          onClose();
        },
        onError: (error) =>
          notify.error("No se pudo actualizar la etiqueta", error),
      },
    );
  };

  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} isCentered size="md">
      <DialogContent>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <DialogHeader>
            <DialogTitle>Editar etiqueta de actividad</DialogTitle>
          </DialogHeader>
          <DialogCloseTrigger />
          <DialogBody>
            <Field
              label="Nombre"
              required
              invalid={!!errors.label}
              errorText={errors.label?.message}
            >
              <Input
                {...register("label")}
                placeholder="Nombre"
                autoComplete="off"
              />
            </Field>
          </DialogBody>
          <DialogFooter>
            <Button variant="outline" onClick={onClose} type="button">
              Cancelar
            </Button>
            <Button colorPalette="brand" type="submit" loading={isPending}>
              Guardar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </DialogRoot>
  );
};
